import { FC } from 'react';
import { ButtonProps, Flex, Image } from '@chakra-ui/react';
import { countries } from '@shinetools/geo-library';

import Button from 'components/_core/Button';
import SunshineDropdown from 'components/_core/SunshineDropdown';
import { Invoice } from 'features/Work/pages/Invoices/hooks/queries/useGetInvoice';
import { Quote } from 'features/Work/pages/Quotes/hooks/queries/useGetQuote';

import locales from './locales';

export interface LanguageOptionsType {
  flag: string;
  label: string;
  value: 'fr' | 'en';
}

export type Item = Invoice | Quote;

interface DownloadPdfButtonProps extends Omit<ButtonProps, 'icon'> {
  item: Item;
  onClickItem: (lang: LanguageOptionsType['value']) => void;
}

const LANGUAGE_OPTIONS: LanguageOptionsType[] = [
  {
    flag: countries.FR.flag,
    label: locales.french,
    value: 'fr',
  },
  {
    flag: countries.GB.flag,
    label: locales.english,
    value: 'en',
  },
];

const DownloadPdfButton: FC<DownloadPdfButtonProps> = ({
  disabled,
  isLoading,
  item,
  onClickItem,
  title,
  ...props
}) => (
  <SunshineDropdown>
    <SunshineDropdown.Trigger>
      <Button icon="chevron-down" isLoading={isLoading} {...props}>
        {title}
      </Button>
    </SunshineDropdown.Trigger>

    <SunshineDropdown.List>
      {LANGUAGE_OPTIONS.map((option) => (
        <SunshineDropdown.Item
          isDisabled={isLoading}
          key={option.value}
          onClick={() => onClickItem(option.value)}
        >
          <Flex alignItems="center" gap="space-8">
            <Image borderRadius="radius-4" src={option.flag} width="20px" />
            {option.label}
          </Flex>
        </SunshineDropdown.Item>
      ))}
    </SunshineDropdown.List>
  </SunshineDropdown>
);
export default DownloadPdfButton;
